import script from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=ts"

import "./AnimatedLogo.vue?vue&type=style&index=0&id=c2e094ae&lang=scss&scoped=true"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e094ae"]])

export default __exports__